import React, {  useState } from "react";
import {  NavLink, useNavigate, useParams } from "react-router-dom";
import Pagination from "@mui/material/Pagination";
import LinearProgress from "@mui/material/LinearProgress";
import Alert from "@mui/material/Alert";
import { useGetVendorStoreByUserIdQuery } from "../apis/VendorStore";
import { useDispatch } from "react-redux";
import { addToCart, setSelectedProductStore } from "../common/slices/productSlice";
import { FaShoppingCart } from "react-icons/fa";
import { getUserData, isAuthenticated } from "../auth";
import { useGetAllShopProfilesByUserIdQuery } from "../apis/ShopProfileApi";

const VendorsListTwoAmazon = () => {
  const dispatch = useDispatch();
  const [active, setActive] = useState(false);
  const [searchString, setSearchString] = useState("");
  const [page, setPage] = useState(1);
  const pageSize = 24;
   const navigate=useNavigate(); 
  const { id } = useParams(); // Extract vendor ID

  const {
    data: searchResults,
    error,
    isLoading,
    isFetching
  } = useGetVendorStoreByUserIdQuery({
    userId: id,
    name: searchString,
    page: page - 1,  // Convert to 0-based index for backend
    size: pageSize
  });
const userData = getUserData();
        const userId = userData?.uid || "";
        console.log('userId userId',userId);

      const { data:profileInfo, error:errorProfileInfo, isLoading:isLoadingProfileInfo } = useGetAllShopProfilesByUserIdQuery(userId, {
        skip: !userId, // Skip the query if userId is not available
      });
  const productsx = searchResults?.vendorStores ? searchResults.vendorStores.map((store) => ({
    ...store.product,
    shopName: store.shopName,
    userName: store.userName,
    shopProfileId: store.shopProfileId,
    adminCommissionRate: store.adminCommissionRate,
    sellerId: store.userId,
    id: store.id,
  })) : [];

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    setSearchString(formData.get("search") || "");
    setPage(1); // Reset to first page on new search
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const sidebarController = () => {
    setActive(!active);
  };
  

  const handleSubmitOld = (product) => {
 
    const isAuthenticate = isAuthenticated(); // Check authentication status once
      if (!isAuthenticate) {
        // Redirect to the login page or account page
        navigate('/account');
      }else{
        if (!product) return;
        dispatch(addToCart(product));
        alert("The product has been added to the cart! Please note: The data is temporarily saved in the cart and will not be finalized until checkout.");    
      }
     
   }; 

   const handleSubmit = (product) => {
    const isAuthenticate = isAuthenticated();
    if (!isAuthenticate) {
      navigate('/account');
    } else {
      if (!product) return;

     // Check if the shop status is approved
if ( profileInfo?.adminCommissionRate !==20) {
  dispatch(addToCart(product));
  alert("The product has been added to the cart! Please note: The data is temporarily saved in the cart and will not be finalized until checkout.");
} else {
  alert("Access denied. The seller can't add to cart.");
}

    }
  };

  if (error) return <Alert severity="error">Error loading data: {error.message}</Alert>;
  if (isLoading || isLoadingProfileInfo) return <LinearProgress />;

  return (
    <section className='vendors-list py-20'>
      <div className={`side-overlay ${active && "show"}`}></div>
      <div className='container container-lg'>
        <div className='row gy-4'>
          <div>
            {/* Top Search */}
            <div className='flex-between flex-wrap gap-8 mb-40'>
              <form
                onSubmit={handleSearchSubmit}
                className='search-form__wrapper position-relative d-block'
              >
                <input
                  name="search"
                  type='text'
                  className='search-form__input common-input py-13 ps-16 pe-18 rounded-pill pe-44'
                  placeholder='Search product '
                  defaultValue={searchString}
                />
                <button
                  type='submit'
                  className='w-32 h-32 bg-main-600 rounded-circle flex-center text-xl text-white position-absolute top-50 translate-middle-y inset-inline-end-0 me-8'
                >
                  <i className='ph ph-magnifying-glass' />
                </button>
              </form>

              <div className='flex-align gap-16'>
                {searchResults && (
                  <span className='text-neutral-600 fw-medium px-40 py-12 rounded-pill border border-neutral-100 d-md-block d-none'>
                    Showing  {(page - 1) * pageSize + 1}-{Math.min(page * pageSize, searchResults.totalItems)} of {searchResults.totalItems} results
                  </span>
                )}
 
              </div>
            </div>

            {/* Products Start */}
            {isFetching && <LinearProgress />}

            <div className='mt-5 row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-3 row-cols-xl-4 row-cols-xxl-6 g-12'>
              {productsx?.map((product) => {
                const discountPrice = product?.price - product?.discount;

                return (
                  <div className='col' key={product.id}>
                    <div className='product-card h-100 p-8 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2'>
                      <NavLink
                        to="/detail-product"
                        onClick={() => product && dispatch(setSelectedProductStore(product))}
                        className='product-card__thumb flex-center'
                      >
                        <img src={product.images?.[0] || "placeholder-image-url"} alt={product.name} />
                      </NavLink>
                      <div className='product-card__content p-sm-2 w-100'>
                        <h6 className='title text-lg fw-semibold mt-12 mb-8'>
                          <NavLink
                            to="/detail-product"
                            onClick={() => product && dispatch(setSelectedProductStore(product))}
                            className='link text-line-2'
                          >
                            {product.name}
                          </NavLink>
                        </h6>
                        <div className='flex-align gap-4'>
                          <span className='text-main-600 text-md d-flex'>
                            <i className='ph-fill ph-storefront' />
                          </span>
                          <span className='text-gray-500 text-xs'>
                            {product.brand}
                          </span>
                        </div>
                        <div className='product-card__content mt-12'>
                          <div className='product-card__price mb-8'>
                            <span className='text-heading text-md fw-semibold '>
                              ${discountPrice.toFixed(2)}{" "}
                              <span className='text-gray-500 fw-normal'>/Qty</span>{" "}
                            </span>
                            {product.discount > 0 && (
                              <span className='text-gray-400 text-md fw-semibold text-decoration-line-through'>
                                ${product.price.toFixed(2)}
                              </span>
                            )}
                          </div>
                          <div className='flex-align gap-6'>
                            <span className='text-xs fw-bold text-gray-600'>
                              {product.ratings || 0}
                            </span>
                            <span className='text-15 fw-bold text-warning-600 d-flex'>
                              <i className='ph-fill ph-star' />
                            </span>
                          </div>

                          <button
                            type="submit"
                            className='product-card__cart btn bg-main-50 text-main-600 hover-bg-main-600 hover-text-white py-11 px-24 rounded-pill flex-align gap-8 mt-24 w-100 justify-content-center'
                            onClick={() => handleSubmit(product)}
                          >
                            <FaShoppingCart className="me-2" />
                            Add to Cart
                          </button>
                           
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Pagination */}
            {searchResults?.totalPages > 1 && (
              <div className="mt-40 flex-center">
                <Pagination
                  count={searchResults.totalPages}
                  page={page}
                  onChange={handlePageChange}
                  color="primary"
                  showFirstButton
                  showLastButton
                  sx={{
                    '& .MuiPaginationItem-root': {
                      borderRadius: '50%',
                      border: '1px solid #e5e7eb',
                      margin: '0 4px',
                      minWidth: '40px',
                      height: '40px'
                    },
                    '& .Mui-selected': {
                      backgroundColor: '#4f46e5',
                      color: '#fff',
                      borderColor: '#4f46e5'
                    }
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default VendorsListTwoAmazon;